var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "17px",
    viewBox: "0 0 26 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5625,1.21875 C23.5625,0.545652961 24.108153,0 24.78125,0 C25.454347,0 26,0.545652961 26,1.21875 L26,15.03125 C26,15.704347 25.454347,16.25 24.78125,16.25 C24.108153,16.25 23.5625,15.704347 23.5625,15.03125 L23.5625,1.21875 Z M13.258375,1.9825 C12.7831383,2.45832851 12.7831383,3.22917149 13.258375,3.705 L16.459625,6.90625 L1.21875,6.90625 C0.545652961,6.90625 -3.33066907e-16,7.45190296 -3.33066907e-16,8.125 C-3.33066907e-16,8.79809704 0.545652961,9.34375 1.21875,9.34375 L16.459625,9.34375 L13.258375,12.545 C12.9323136,12.8488272 12.7980951,13.3064028 12.9083735,13.7382195 C13.0186519,14.1700362 13.3558388,14.5072231 13.7876555,14.6175015 C14.2194722,14.7277799 14.6770478,14.5935614 14.980875,14.2675 L20.262125,8.98625 L21.125,8.125 L20.26375,7.26375 L14.9825,1.9825 C14.7539176,1.75377108 14.4438054,1.62526019 14.1204375,1.62526019 C13.7970696,1.62526019 13.4869574,1.75377108 13.258375,1.9825 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.20319364ae5df2dd1cdbe7762a7c89a9.svg";
export { ForwardRef as ReactComponent };